import { render, staticRenderFns } from "./ProuniOtherDocuments.vue?vue&type=template&id=68e866d1&scoped=true&"
import script from "./ProuniOtherDocuments.vue?vue&type=script&lang=ts&"
export * from "./ProuniOtherDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniOtherDocuments.vue?vue&type=style&index=0&id=68e866d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e866d1",
  null
  
)

export default component.exports